import type { Action } from 'redux'
import type { LoginRequest, User } from '../../../domain/models/user'
import { LOGOUT } from '../types/log-out-types'
import * as types from '../types/login-types'

export const InitialStateLogin = {
  user: null as unknown as User,
  loginUpdate: {} as Partial<LoginRequest>,
  load: false,
  error: '',
}

export const loginReducer = (
  state = InitialStateLogin,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }
  switch (action.type) {
    case types.LOGIN_REQUEST:
      newState.load = true
      return newState

    case types.LOGIN_ERROR:
      newState.load = false
      newState.error = action.payload
      return newState

    case types.LOGIN_SUCCESS:
      newState.load = false
      newState.error = ''
      newState.user = action.payload
      return newState

    case types.LOGIN_UPDATE:
      return {
        ...state,
        loginUpdate: {
          ...state.loginUpdate,
          ...action.payload,
        },
      }

    case types.LOGIN_RESET:
      if (action.payload) {
        return InitialStateLogin
      } else {
        return { ...state, error: '' }
      }

    case LOGOUT:
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      sessionStorage.clear()
      return InitialStateLogin

    default:
      return { ...state }
  }
}
